/* unplugin-vue-components disabled */import { render } from "./SlideDeckBackgroundItem.vue?vue&type=template&id=cadb6bea&scoped=true&ts=true"
import script from "./SlideDeckBackgroundItem.vue?vue&type=script&lang=ts"
export * from "./SlideDeckBackgroundItem.vue?vue&type=script&lang=ts"

import "./SlideDeckBackgroundItem.vue?vue&type=style&index=0&id=cadb6bea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cadb6bea"]])

export default __exports__